module.exports = __webpack_public_path__ + "static/media/arrow-up.a817f15a.svg";